import React from "react";

function SvgIcMapPoi007(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 25l-1.798-5.676 1.512-1.51a.749.749 0 000-1.057l-.563-.563a.75.75 0 00-1.059 0l-.551.548-.739-2.897c1.587-1.588 6.087-6.618 5.027-7.676-1.057-1.059-6.087 3.441-7.674 5.029l-2.952-.755.57-.569a.751.751 0 000-1.059l-.53-.528a.751.751 0 00-1.059 0l-1.509 1.51L7 8l-.982 1.043L14 15c-1.66 1.658-2.28 2.494-4 5H6l-1 1 3.107 2C7.5 24 8 24.583 9 24l2 3 1-1v-4c2.505-1.72 3.34-2.341 5-4l6 8.056L24 25z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi007;
